@if (isLoading) {
  <csl-services-list-skeleton />
} @else {
  @if (services?.length) {
    <section [attr.aria-labelledby]="headingId">
      <h2 id="{{ headingId }}" class="mt-14 text-xl font-bold leading-8 text-blue-900">
        {{ serviceType$$() === ServiceType.Residential ? 'Residential Services' : 'Commercial Services' }}
      </h2>
      <p class="text-gray-750 mb-6 text-base">{{ description$$() }}</p>

      @for (service of services; track service.id; let last = $last) {
        <div
          class="relative flex flex-col items-center justify-center md:flex-row md:items-stretch"
          [ngClass]="{ 'mb-4': !last }"
          data-testid="service-card-root"
        >
          <div class="absolute left-0 top-0 h-full w-full rounded-3xl border border-solid border-gray-200"></div>
          <div
            [ngStyle]="{ 'background-image': 'url(images/residential/' + service.code + '.webp)' }"
            class="z-10 h-[184px] w-full flex-shrink-0 rounded-3xl bg-cover bg-[20%_center] md:h-auto md:max-w-40 lg:max-w-[180px]"
          ></div>
          <div class="flex flex-auto flex-row items-center self-stretch px-6 py-4 md:px-4">
            <div class="flex flex-col items-start justify-between gap-y-4 self-stretch md:gap-y-1.5">
              <div class="flex flex-col items-start justify-start gap-1 gap-y-1">
                <div class="md:-lg:text-base text-lg font-bold text-blue-900" data-testid="service-type">
                  {{ service.type }}
                </div>
                <div class="text-gray-750 text-xs" data-testid="service-description">
                  {{ service.description }}
                </div>
              </div>
              <div
                class="text-gray-750 flex flex-col items-start justify-start gap-1 gap-y-1 self-stretch text-xs"
                data-testid="row-data"
              >
                @if (service.frequencies.length) {
                  <div class="flex gap-1">
                    <csl-icon name="frequency-icon" class="mr-1 size-4 bg-green-600" data-testid="row-icon-frequency" />
                    @if (serviceType$$() === ServiceType.Residential) {
                      {{ service.frequencies.join(' / ') }}
                    } @else {
                      @if (service.frequencies[0] !== oneTimeService) {
                        Up to
                      }
                      {{ service.frequencies[0] | titlecase }}
                      <!-- most frequent -->
                    }
                  </div>
                }

                @if (service.containerSizes?.length) {
                  <div class="flex gap-1">
                    <i
                      class="g-filter-green-600 mr-1 inline-block size-4 min-w-4 bg-[url(../assets/icons/volume-icon.svg)]"
                      data-testid="row-icon-trash"
                    ></i>
                    Up to {{ service.containerSizes![0] | gallonToGal | titlecase | pluralizeUnit }}
                    @if (serviceType$$() === ServiceType.Residential) {
                      Gal
                    }
                  </div>
                }
              </div>
            </div>
          </div>

          <div
            class="z-10 flex flex-shrink-0 flex-col items-start justify-between gap-y-0 self-stretch px-6 pb-6 pt-4 md:basis-[200px] md:p-4"
          >
            <div
              class="text-gray-750 flex flex-1 flex-col items-start justify-center gap-0.5 gap-y-0 self-stretch text-xs md:m-4"
            >
              @if (service.minimumPrice) {
                <div class="text-regent-gray-750 flex items-center justify-start self-stretch">from</div>
                <div class="flex flex-row items-end justify-start self-stretch pb-4 md:pb-0">
                  <div class="md:-md:text-lg text-xl font-bold leading-8 text-blue-900" data-testid="service-min-price">
                    {{ service.minimumPrice | currency }}
                  </div>

                  @if (!service.isOneTimeService) {
                    <div class="text-regent-gray-750 flex flex-1 flex-row items-center justify-start pb-1 pt-1">
                      /month
                    </div>
                  }
                </div>
              } @else {
                <div class="text-regent-gray-750 mb-4 self-stretch text-center text-sm md:mb-0">
                  We will contact you regarding the price
                </div>
              }
            </div>
            <div class="flex flex-row items-center justify-center gap-2 gap-y-0 self-stretch">
              <button
                class="flex-shrink-0 flex-grow md:flex-grow-0"
                cslButton
                type="button"
                data-testid="order_service"
                [attr.aria-label]="
                  (isResidentialService(service.code) ? 'Order ' : 'Request ') + service.type + ' Service'
                "
                (click)="orderService(service)"
              >
                {{ isResidentialService(service.code) ? 'Order' : 'Request' }} Service
              </button>
            </div>
          </div>
        </div>
      }
    </section>
  } @else {
    <csl-services-unavailable
      aria-atomic="true"
      aria-live="assertive"
      (contactUsClick)="contactUsClick.emit($event)"
      (openCitiesClick)="openCitiesClick.emit($event)"
    />
  }
}
